module.exports = __webpack_public_path__ + "img/podium_3078.4bd5e425.jpg";